import { render } from "./beneficiary_id_order_by_power_for_management.vue?vue&type=template&id=226b055c&scoped=true"
import script from "./beneficiary_id_order_by_power_for_management.vue?vue&type=script&lang=js"
export * from "./beneficiary_id_order_by_power_for_management.vue?vue&type=script&lang=js"

import "./beneficiary_id_order_by_power_for_management.vue?vue&type=style&index=0&id=226b055c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226b055c"]])

export default __exports__